var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShape(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#464646",
    fillRule: "nonzero",
    d: "M7.417 9.04l.255-.641a2.415 2.415 0 0 0 3.205-2.94l.66-.197a3.105 3.105 0 0 1-4.12 3.779zm-5.76-2.926c-.092.1-.178.195-.258.286.6.68 1.255 1.308 1.96 1.877.375.304.76.584 1.154.837l-.374.58C1.943 8.281.5 6.4.5 6.4s3.707-4.83 8.28-4.83c.983 0 1.926.224 2.801.573l-.529.537a6.692 6.692 0 0 0-2.272-.42c-1.817 0-3.66.842-5.422 2.263a16.087 16.087 0 0 0-1.7 1.59zm14.246.572c.092-.1.178-.195.258-.286-.6-.68-1.255-1.308-1.96-1.877-.262-.212-.53-.414-.802-.602l.393-.567C15.777 4.73 17.06 6.4 17.06 6.4s-3.707 4.83-8.28 4.83a7.422 7.422 0 0 1-2.548-.476l.552-.54a6.563 6.563 0 0 0 1.996.326c1.817 0 3.66-.842 5.422-2.263a16.087 16.087 0 0 0 1.7-1.59zm-5.754-3.074l-.304.62a2.415 2.415 0 0 0-3.27 3.155l-.63.283a3.105 3.105 0 0 1 4.204-4.058zM14.795 0l.488.487L2.728 13.043l-.488-.488L14.795 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/shape.1b410350cf2a4bdfc43ee0f45a4e3a80.svg";
export { ForwardRef as ReactComponent };